import {EventEmitter, Injectable} from '@angular/core';
import {InstrumentoInterface} from "../models/instrumento.interface";
import {Subscription} from "rxjs";
import {AppHelper} from "../helpers/app.helper";
import {RequestService} from "./request.service";
import {InstrumentoService} from "./instrumento.service";

import { Store } from '@ngxs/store';
import { CarteraState } from '../states/cartera.state';
import { OperacionSimboloInterface } from '../models/operacion-simbolo.interface';
import { PaginationState } from '../states/pagination.state';
import { OperationsSymbolState } from '../states/operations-symbol.state';

interface Dic { [key: number]: Subscription }
interface Topic { [key: string]: Dic }
type SubscriptionFunction = (instrumentos: InstrumentoInterface[]) => void;

@Injectable({
  providedIn: 'root'
})
export class PriceUpdateService {

  /** Intervalo de actualización: s **/
  private _interval = 30;

  /** Contiene la lista de Instrumentos a atualizar su precio **/
  private queue: Topic = {};

  onPriceChanged = new EventEmitter<InstrumentoInterface[]>();

  timeSubscription: Subscription;

  timeUpdater = new EventEmitter();

  get interval(): number {
    return this._interval;
  }

  set interval(value: number) {
    this._interval = value;
    this.timeSubscription?.unsubscribe();
    this.subscribeTimeUpdater();
  }

  constructor(private requestService: RequestService,
              private store: Store,
              private intrumentoService: InstrumentoService) {
               
   
  }

  async startTimeUpdater(){

    console.log('startTimeUpdater()');
    
    this.subscribeTimeUpdater();
    this.updatePrice();
    
  }

  async stopTimeUpdater(){

    this.timeSubscription?.unsubscribe();
    
  }

  private async subscribeTimeUpdater() {

    this.timeSubscription?.unsubscribe();

    this.timeSubscription = this.timeUpdater.subscribe(() => {

      AppHelper.DevPrint(`Update price in ${this._interval}s`);
      this.updatePrice();
    });
   
  }

  async updatePrice(cycle = true) {

    let collection: string[] = [];
    let idQuery = '';

   this.getIDs().forEach(item => {
      collection.push(item);
    });

    this.getStoreInstruments().forEach(item => {
      if(collection.indexOf(String(item.simbolo.id)) === -1){
              collection.push(String(item.simbolo.id));
      }
    });


    collection.forEach( item => {
      idQuery = idQuery + `id[]=${item}&`;
    })

   if(idQuery){

      const data: InstrumentoInterface[] = await this.intrumentoService
        .obtenerIntrumentos({}, `pageable=0&${idQuery}`, true);

      this.onPriceChanged.emit(data);
   }
      await AppHelper.Wait(1000 * this._interval);

      if (cycle) {
        this.timeUpdater.emit();
      }
    
  }

  addToQueue(topic: string, id: number, fn: SubscriptionFunction) {

    if (!this.queue[topic]) {

      this.queue[topic] = {};
    }

    if (!this.queue[topic][id]) {

      this.queue[topic][id] = this.onPriceChanged.subscribe(fn);
    }
  }

  getStoreInstruments(){

    let subscription: any;

    let array = [];

    subscription = this.store.select(OperationsSymbolState.operationsSymbolData).subscribe((opsims: OperacionSimboloInterface[]) => {

    //subscription = this.store.select(CarteraState.pagination).subscribe((opsims: PaginationStateInterface[]) => {
      

      array = opsims;
    //array = opsims.data;

      
      return array;


      //const el: any = array.find(a => a.id === this.id);

    });

    return array;

  }

  removeFromQueue(topic: string, id: number) {

    try{

      if (this.queue[topic] && this.queue[topic][id]) {

        this.queue[topic][id].unsubscribe();
        delete this.queue[topic][id];
      }

    } catch (e) {

      AppHelper.DevPrint(e);
    }
  }

  getIDs() {
    let ids = [];
    Object.values(this.queue).forEach((dic: Dic) => {

      ids = [ ... ids, ...Object.keys(dic).filter(k => ids.indexOf(k) < 0) ];
    });

    return ids;
  }

}
